import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_player_refresh",
  "use": "icon-video_player_refresh-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video_player_refresh\">\n\t<path d=\"M17 13.0648C15.7569 15.6816 13.0897 17.4907 10 17.4907C6.91027 17.4907 4.24309 15.6816 3 13.0648V16.3842M3 6.42592C4.24309 3.80915 6.91027 2 10 2C13.0897 2 15.7569 3.80915 17 6.42592V3.10648\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n\t</symbol>"
});
var result = sprite.add(symbol);
export default symbol